/* eslint-disable */

import PropTypes from "prop-types";
//Styles
import styled from "styled-components";
import React from "react";

function variantModifier(theme) {
  return {
    primary: `
    color: ${theme.components.button.primaryColor};
    background-color: ${theme.components.button.primaryBackgroundColor};
    border: 1px solid ${theme.components.button.primaryBorderColor};
    :hover {
      color:${theme.components.button.primaryHoverColor};
      background-color: ${theme.components.button.primaryHoverBackgroundColor};
    }
    :focus {
      outline: 2px solid ${theme.components.button.primaryFocus};
    }
    :before {
      background-color: ${theme.components.button.primaryIconBackgroundColor};
    }
    :after {
      color: ${theme.components.button.primaryIconColor};
    }
  `,
    dark: `
    color: ${theme.components.button.darkColor};
    background-color: ${theme.components.button.darkBackgroundColor};
    border: 1px solid ${theme.components.button.darkBorderColor};
    :hover {
      color: ${theme.components.button.darkHoverColor};
      background-color:${theme.components.button.darkHoverBackgroundColor};
    }
    :focus {
      outline: 2px solid ${theme.components.button.darkFocus};
    }
    :before {
      background-color: ${theme.components.button.darkIconBackgroundColor};
    }
    :after {
      color: ${theme.components.button.darkIconColor};
    }
  `,
    light: `
    color: ${theme.components.button.lightColor};
    background-color: ${theme.components.button.lightBackgroundColor};
    border: 1px solid ${theme.components.button.lightBorderColor};
    :hover {
      color: ${theme.components.button.lightHoverColor};
      background-color: ${theme.components.button.lightHoverBackgroundColor};
    }
    :focus {
      outline: 2px solid ${theme.components.button.lightFocus};
    }
    :before {
      background-color: ${theme.components.button.lightIconBackgroundColor};
    }
    :after {
      color: ${theme.components.button.lightIconColor};
    }
  `,
    default: `
    color: ${theme.components.button.color};
    background-color: ${theme.components.button.backgroundColor};
    border: 1px solid ${theme.components.button.borderColor};
    :hover {
      color: ${theme.components.button.hoverColor};
      background-color: ${theme.components.button.hoverBackgroundColor};
    }
    :focus {
      outline: 2px solid ${theme.components.button.focus};
    }
    :before {
      background-color: ${theme.components.button.iconBackgroundColor};
    }
    :after {
      color: ${theme.components.button.iconColor};
    }
  `
  };
}

const Button = styled.button`
  /*
  -- Variant
  */
  ${props => variantModifier(props.theme)[props.variant || "default"]};
  /*
  -- Shared default Styles
  */
  font-size: ${props =>
    props.fontSize || props.theme.components.button.fontSize};
  font-weight: ${props =>
    props.fontWeight || props.theme.components.button.fontWeight};
  padding: ${props => props.padding || props.theme.components.button.padding};
  line-height: ${props =>
    props.lineHeight || props.theme.components.button.lineHeight};
  /*
  -- Always the same
  */
  border: ${props => props.border};
  color: ${props => props.color};
  background-color: ${props => props.backgroundColor};
  position: relative;
  border-radius: 0;
  cursor: pointer;
  /*
  -- Before & After for cutting effect
  */
  :before,
  :after {
    height: 36px;
    width: 36px;
    position: absolute;
    top: -20px;
    right: -19px;
  }

  :before {
    content: "";
    transform: rotate(45deg);
    background-color: ${props => props.backgroundColor};
  }

  :after {
    content: "+";
    color: ${props => props.color};
    font-size: 22px;
    font-weight: 100;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: transparent;
  }
`;

Button.propTypes = {
  variant: PropTypes.string.isRequired,
  fontSize: PropTypes.string,
  fontWeight: PropTypes.string,
  padding: PropTypes.string,
  lineHeight: PropTypes.string,
  border: PropTypes.string,
  color: PropTypes.string,
  backgroundColor: PropTypes.string
};

export default Button;
